// Random way of getting unique values for my 'enums'
import {fillArray} from "./utils";

const I_MIN = 0;
let I = I_MIN;
const resetI = () => I = I_MIN;
const incrI = () => I++;

export const objectifyArray = (en, arr) => {
    let keys = Object.keys(en).map(str => str.toLowerCase());
    if(keys.length !== arr.length) {
        throw new Error(`Array length doesn't match type: ${JSON.stringify(en)} vs ${JSON.stringify(arr)}`);
    }
    let result = {};
    for(let i = 0, n = keys.length; i < n; i++) {
        result[keys[i]] = arr[i];
    }
    return result;
};

export const arrayifyObject = (en, obj) => {
    let en_keys = Object.keys(en);
    let keys = en_keys.map(str => str.toLowerCase());
    // @ASSUMPTION Object.keys gives me the keys in the declared order (if not, then things won't be in the correct order!)
    return keys.map(key => obj[key]);
};


resetI()
export const DATATYPE = {
    PERSON: incrI(),
    COMPANY: incrI(),
    REQUEST: incrI(),
    DEAL: incrI(),
    PROMOTION: incrI(),
    PERSON_COMPANY: incrI(),
};

export const REQUEST_GENERAL = {
    NEXT_ACTION: `What specifically needs to happen? Who needs to do it? When is it expected to be done? What happens after that? eg "Email John specific changes to contract X by Weds. He will then respond with changes."`,
};

export const OBJECT_TYPE = {
    PERSON: 'person',
    COMPANY: 'company',
    REQUEST: 'request',
    DEAL: 'deal',
    PROMOTION: 'promotion',

    INBOX: 'inbox', // NB special type for saving inbox entries
};

// Logs
resetI();
export const LOG_MESSAGE_TYPE = {
    OBJECT_CREATED: incrI(),
    CONTACTED: incrI(),
    ACTION_COMPLETED: incrI(),
    USER_ENTRY: incrI(),
};



// Person

const example_person = [
    'id',
    'first name',
    'last name',
    'email1, email2, email3, ...',
    'phone1, phone2, phone3, ...',
    'tag1, tag2, tag3',
// v1
    'description',
// v3
    [], // list of filenames
];

resetI();
export const I_PERSON = {
    ID: incrI(),            // ''
    FIRST_NAME: incrI(),    // ''
    LAST_NAME: incrI(),     // ''
    EMAILS: incrI(),        // '' - comma separated list
    PHONE_NUMBERS: incrI(), // '' - comma separated list
    TAGS: incrI(),          // '' - comma separated list
// v1
    DESCRIPTION: incrI(),   // ''
// v3
    FILES: incrI(), // [] - list of filenames
}
export const PERSON_LABELS = {
    TAGS: `TODO - instructions for tags`,
    DESCRIPTION: `TODO - instructions for description`,
};

export const getNullPerson = () => ['', '', '', '', '', '', '', []];
export const personAsObject = person_arr => objectifyArray(I_PERSON, person_arr);
export const personFromObject = person_obj => arrayifyObject(I_PERSON, person_obj);


// Company

const example_company = [
    'id',
    'company name',
// v1
    'description',
// v3
    [], // list of filenames
];

resetI();
export const I_COMPANY = {
    ID: incrI(),      // ''
    NAME: incrI(),    // ''
// v1
    DESCRIPTION: incrI(),   // ''
// v3
    FILES: incrI(), // [] - list of filenames
}
export const COMPANY_LABELS = {
    DESCRIPTION: `TODO - instructions for description`,
};

export const getNullCompany = () => ['', '', '', []];
export const companyAsObject = company_arr => objectifyArray(I_COMPANY, company_arr);
export const companyFromObject = company_obj => arrayifyObject(I_COMPANY, company_obj)



export const getDefaultRelated = () => {
    return {type: -1, id: ''};
}

// Request

const example_request = [
    'id',
    'person_id',
    '2023-02-23T07:52:05.837Z',
    'description',
// v1
    '2023-02-23T07:52:05.837Z',
    'title',
    'status',
// v2
    {waiting_for: false, details: 'text describing details'},  // next action.. what needs to happen next, who needs to do it?
    [
        {type: DATATYPE.PERSON, id: ''}
    ], // related person or company - ( NB can get to deals etc through the company to make things simpler for UI)
// v3
    [], // list of filenames
];
export const REQUEST_EXPLANATION = `A Request is an incoming message from someone looking for you to help them with something, e.g. find a product/service/professional/person = an opportunity for us to make a commission.`;

resetI();
export const I_REQUEST = {
    ID: incrI(),
    ID_PERSON: incrI(),
    UPDATED: incrI(),
    DESCRIPTION: incrI(),
// v1
    CREATED: incrI(),   // ''
    TITLE: incrI(),   // ''
    STATUS: incrI(),   // ''
// v2
    NEXT_ACTION: incrI(),   // {waiting_for: false, details: ''}
    RELATED: incrI(),   // [ {type: DATATYPE.PERSON, id: ''}, ... ]
// v3
    FILES: incrI(), // [] - list of filenames
};
export const REQUEST_LABELS = {
    TITLE: `TODO - instructions for title`,
    DESCRIPTION: `Include specific details of the request being made, where to find the original message(s), and initial ideas of what person/company/deal might satisfy the request.`
};
export const getNullRequest = () => ['', '', '', '', '', '', '', {waiting_for: false, details: ''}, [], []];
export const requestAsObject = request_arr => objectifyArray(I_REQUEST, request_arr);
export const requestFromObject = request_obj => arrayifyObject(I_REQUEST, request_obj);


// Deal

const example_deal = [
    'id',
    '2023-02-23T07:52:05.837Z',
    'company_id',
    'description',
    [
        'promotion_id',
        'promotion_id',
    ],
// v1
    '2023-02-23T07:52:05.837Z',
    'title',
    'status',
// v2
    {waiting_for: false, details: 'text describing details'},  // next action.. what needs to happen next, who needs to do it?
    [
        {type: DATATYPE.PERSON, id: ''}
    ], // related person or company - ( NB can get to deals etc through the company to make things simpler for UI)
// v3
    [], // list of filenames
];

export const DEAL_EXPLANATION = `A Deal is an agreement we want to make/are negotiating/have made with a Company for commission (or other payment)`;

resetI();
export const I_DEAL = {
    ID: incrI(),
    CREATED: incrI(),
    ID_COMPANY: incrI(),
    DESCRIPTION: incrI(),
    LIST_PROMOTIONS: incrI(),
// v1
    UPDATED: incrI(),   // ''
    TITLE: incrI(),   // ''
    STATUS: incrI(),   // ''
// v2
    NEXT_ACTION: incrI(),   // {waiting_for: false, details: ''}
    RELATED: incrI(),   // [ {type: DATATYPE.PERSON, id: ''}, ... ]
// v3
    FILES: incrI(), // [] - list of filenames
};
export const DEAL_LABELS = {
    TITLE: `TODO - instructions for title`,
    DESCRIPTION: `Include details like: what product/service/thing this deal relates to, who it might appeal to, any commission &percnt; agreed, significant people involved, &pound; sizes in play`
};
export const getNullDeal = () => ['', '', '', '', [], '', '', '', {waiting_for: false, details: ''}, [], []];
export const dealAsObject = deal_arr => objectifyArray(I_DEAL, deal_arr);
export const dealFromObject = deal_obj => arrayifyObject(I_DEAL, deal_obj);


// Promotion

const example_promotion = [
    'id',
    '2023-02-23T07:52:05.837Z',
    'id_deal',
    'title',
    [
        ['person_id', 'status'], // SHORTLIST_PEOPLE
        ['person_id', 'status'],
    ],
// v1
    '2023-02-23T07:52:05.837Z',
    'description',
    'status',
// v2
    {waiting_for: false, details: 'text describing details'},  // next action.. what needs to happen next, who needs to do it?
    [
        {type: DATATYPE.PERSON, id: ''}
    ], // related person or company - ( NB can get to deals etc through the company to make things simpler for UI)
// v3
    [], // list of filenames
];
export const PROMOTION_EXPLANATION = `A Promotion is an active outreach campaign, where we find people to send to Deals we have agreed with Companies, e.g. WhatsApp-ing 10 people to see if they want to do X`;

resetI();
export const I_PROMOTION = {
    ID: incrI(),
    CREATED: incrI(),
    ID_DEAL: incrI(),
    TITLE: incrI(),
    LIST_SHORTLIST_PEOPLE: incrI(),
// v1
    UPDATED: incrI(),   // ''
    DESCRIPTION: incrI(),   // ''
    STATUS: incrI(),   // ''
// v2
    NEXT_ACTION: incrI(),   // {waiting_for: false, details: ''}
    RELATED: incrI(),   // [ {type: DATATYPE.PERSON, id: ''}, ... ]
// v3
    FILES: incrI(), // [] - list of filenames
};
export const PROMOTION_LABELS = {
    TITLE: `A short description of who you're targeting with this promotion, an 'angle' you're taking, and how/when you're going to be contacting them - e.g. Xmas themed text messages to families with 2+ kids who've responded +vly to holiday offers before`,
    DESCRIPTION: `TODO - instructions for description`,
};
export const getNullPromotion = () => ['', '', '', '', [], '', '', '', {waiting_for: false, details: ''}, [], []];
export const promotionAsObject = promotion_arr => objectifyArray(I_PROMOTION, promotion_arr);
export const promotionFromObject = promotion_obj => arrayifyObject(I_PROMOTION, promotion_obj);

resetI();
export const I_SHORTLIST_PEOPLE = {
    ID_PERSON: incrI(),
    STATUS: incrI(),
};
export const getNullShortlistPerson = () => fillArray('', Object.keys(I_SHORTLIST_PEOPLE).length);
export const shortlistPersonAsObject = shortlist_person_arr => objectifyArray(I_SHORTLIST_PEOPLE, shortlist_person_arr);
export const shortlistPersonFromObject = shortlist_person_obj => arrayifyObject(I_SHORTLIST_PEOPLE, shortlist_person_obj);


// Shortlist

// const example_shortlist = [
//     'id',
//     '2023-02-23T07:52:05.837Z',
//     'promotion_id',
//     [
//         ['person_id', 'status'], // SHORTLIST_PEOPLE
//         ['person_id', 'status'],
//     ]
// ];
//
// resetI();
// export const I_SHORTLIST = {
//     ID: incrI(),
//     CREATED: incrI(),
//     ID_PROMOTION: incrI(),
//     LIST_SHORTLIST_PEOPLE: incrI(),
// };
// export const getNullShortlist = () => ['', '', '', []];
// export const shortlistAsObject = shortlist_arr => objectifyArray(I_SHORTLIST, shortlist_arr);
// export const shortlistFromObject = shortlist_obj => arrayifyObject(I_SHORTLIST, shortlist_obj);


// Person-Company

const example_person_company = [
    'person_id',
    'company_id',
    'position/title'
];

resetI();
export const I_PERSON_COMPANY = {
    ID_PERSON: incrI(),   // ''
    ID_COMPANY: incrI(),  // ''
    POSITION: incrI(),    // ''
}

export const getNullPersonCompany = () => fillArray('', Object.keys(I_PERSON_COMPANY).length);
export const personCompanyAsObject = arr => objectifyArray(I_PERSON_COMPANY, arr);
export const personCompanyFromObject = obj => arrayifyObject(I_PERSON_COMPANY, obj);
